import React, { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { useCookies } from "react-cookie";
import useWeglot from "../hooks/useWeglot";
import { FullScreenLoader } from "./FullScreenLoader";

export const loader = async (request: any) => {
    const uuid = await request.params.uuid;
    return { uuid };
};

const Redirect = () => {
    const uuid = (useLoaderData() as any).uuid as string;

    const [cookies, setCookie, removeCookie] = useCookies([
        "uuid",
        "brand_id",
        "theme_color",
    ]);
    const [applyingLang, setApplyingLang] = useState(true);
    const [uuidConfirmed, setUuidConfirmed] = useState(false);

    useWeglot();

    useEffect(() => {
        // Step 1: Clear old state and apply new UUID + language
        // Remove existing cookies
        localStorage.removeItem("uuid");
        removeCookie("brand_id", { path: "/" });
        removeCookie("uuid", { path: "/" });
        removeCookie("theme_color", { path: "/" });

        // Set new UUID cookie
        setCookie("uuid", uuid, { path: "/" });
        localStorage.setItem("uuid", uuid);

        // Parse the "lang" parameter from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const lang = urlParams.get("lang");

        // Apply the language using Weglot
        if (lang && lang !== "undefined" && window.Weglot) {
            window.Weglot.switchTo(lang);
        }
        setApplyingLang(false);
    }, [uuid, setCookie, removeCookie]);

    // Step 2: Wait until UUID is confirmed in both places
    useEffect(() => {
        const cookieOk = cookies.uuid === uuid;
        const localOk = localStorage.getItem("uuid") === uuid;
        if (cookieOk && localOk) {
            console.log("UUID: ", uuid);
            console.log("Cookies: ", cookies.uuid);
            console.log("LS: ", localStorage.getItem("uuid"));
            setUuidConfirmed(true);
        }
    }, [cookies.uuid, uuid]);

    // Step 3: Redirect once all 3 conditions are met
    useEffect(() => {
        if (!applyingLang && uuidConfirmed) {
            window.location.href = "/";
        }
    }, [applyingLang, uuidConfirmed]);

    return <FullScreenLoader />;
};

export default Redirect;
